import { ClipboardList, Home, LayoutGrid, PlusCircle, Settings } from 'lucide-react';

export const primaryNavItems = [
  { to: '/', label: 'Home', Icon: Home, exact: true },
  { to: '/tutti-gli-inviti', label: 'Inviti', Icon: ClipboardList },
  { to: '/eventi', label: 'Eventi', Icon: LayoutGrid },
  { to: '/editor-invito', label: 'Crea invito', Icon: PlusCircle },
];

export const settingsNavItem = {
  to: '/impostazioni',
  label: 'Impostazioni',
  Icon: Settings,
};

export function isNavItemActive(pathname, { to, exact }) {
  return exact ? pathname === to : pathname.startsWith(to);
}
